import React from 'react';

const Privacy = () => (
  <section className="page">
    <h1>Privacy Policy</h1>

    <h2>Data We Store</h2>
    <p>
      Hestia Ledger stores your user data—like transactions, bills, and whatever else you put in—on a 
      MongoDB database. Your password’s encrypted, but the rest? Not really. I’m not some security wizard, 
      just a guy building an app. I don’t look at your stuff, don’t sell it, and don’t plan to do anything 
      shady with it. It’s there so the app works—use it at your own risk.
    </p>

    <h2>Google Analytics</h2>
    <p>
      This site (hestialedger.com) uses Google Analytics to track basic stuff—page views, clicks, that 
      kind of thing. It’s just me trying to see if anyone’s actually showing up. Google gets some anonymized 
      data from that (check their <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">policy</a> 
      for details), but I’m not running ads or handing your info to anyone else.
    </p>

    <h2>My Promise</h2>
<p>
  I’m Blueprint Byte, not a data-hoarding corp. No ads, no sneaky monetization—just an app to help you 
  track your finances. If that changes, I’ll let you know. Questions? Hit me at 
  <a href="mailto:bell@hestialedger.com">bell@hestialedger.com</a>.
</p>

    <a href="http://app.hestialedger.com" className="cta-button">Try Now!</a>
  </section>
);

export default Privacy;